import { useState } from "react";
import { Menu, Phone } from "lucide-react";
import { Button } from "../ui/button";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { ASSETS, CONTACT } from "../../config/site";

const NAV = [
  { label: "The Estate", href: "/#about" },
  { label: "Location", href: "/#location" },
  { label: "Master Plan", href: "/#master-plan" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Incentives", href: "/#incentives" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/#faq" },
];

export const Wordmark = ({ light = false }) => (
  <a href="/#top" className="flex flex-col leading-none" data-testid="brand-wordmark">
    <span className="font-display text-2xl sm:text-3xl font-semibold tracking-wide text-gold">
      BIDC
    </span>
    <span
      className={`mt-1 text-[9px] sm:text-[10px] uppercase tracking-[0.28em] ${
        light ? "text-paper/70" : "text-[#4A4C4A]"
      }`}
    >
      Tirupati Developers
    </span>
  </a>
);

export const Logo = ({ light = false, className = "h-11 sm:h-12" }) => {
  const [ok, setOk] = useState(true);
  const asset = light ? ASSETS.logoWhite : ASSETS.logoGold;
  if (!ok) return <Wordmark light={light} />;
  return (
    <a href="/#top" data-testid="brand-logo">
      <img
        src={asset.local}
        onError={() => setOk(false)}
        alt="Tirupati Developers — BIDC"
        className={`${className} w-auto object-contain`}
      />
    </a>
  );
};

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b border-border/70 bg-paper/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 sm:h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Logo />

        <nav className="hidden lg:flex items-center gap-7" data-testid="desktop-nav">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-[#4A4C4A] hover:text-forest transition-colors duration-200"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:+91${CONTACT.primaryPhone}`}
            data-testid="header-call-button"
            className="hidden md:flex items-center gap-2 text-sm font-medium text-forest hover:text-forest-light transition-colors duration-200"
          >
            <Phone className="h-4 w-4" /> {CONTACT.primaryPhone}
          </a>
          <Button
            asChild
            data-testid="header-book-visit-button"
            className="hidden sm:inline-flex bg-forest text-paper hover:bg-forest-light transition-colors duration-200"
          >
            <a href="/#contact">Book a Site Visit</a>
          </Button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                aria-label="Open menu"
                data-testid="mobile-menu-button"
                className="lg:hidden inline-flex h-10 w-10 items-center justify-center border border-border text-forest"
              >
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-paper border-border w-72">
              <div className="mt-8 flex flex-col gap-1">
                {NAV.map((n) => (
                  <a
                    key={n.href}
                    href={n.href}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="border-b border-border/60 py-3.5 font-display text-xl text-forest"
                  >
                    {n.label}
                  </a>
                ))}
                <Button
                  asChild
                  className="mt-6 bg-forest text-paper hover:bg-forest-light"
                  data-testid="mobile-book-visit-button"
                >
                  <a href="/#contact" onClick={() => setOpen(false)}>
                    Book a Site Visit
                  </a>
                </Button>
                <a
                  href={`tel:+91${CONTACT.primaryPhone}`}
                  className="mt-4 flex items-center gap-2 text-sm text-[#4A4C4A]"
                >
                  <Phone className="h-4 w-4" /> Call {CONTACT.primaryPhone}
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
